import $http from '../../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Cargar los pagos de la empresa y licencia actuales.
 * 
 * @param commit
 * @param object payload contine: { idLicense, idCompany, page }
 *  integer idLicense: id Licencia actual. 
 *  integer idCompany: id Empresa actual.
 *  integer page: pagina actual.
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function getAllByCompany({ commit }, { idLicense, idCompany, page, sortBy, sort, per_page }) {

  commit('setMonthlyPayments', []);
  commit('dashboard/load', true, { root: true });

  await $http.get(`licenses/monthly-payments/license/${idLicense}/company/${idCompany}?page=${page}&sortBy=${sortBy}&sort=${sort}&per_page=${per_page}`)
    .then(({ data: response }) => {

      if (response.statusCode == 200) {
        commit('setMonthlyPayments', response.payload);
        return false;
      }
        
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Pagos de la licencia',
        text: response.message,
        showConfirmButton: false,
      })

    })
    .catch(() => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Pagos de la licencia',
        text: 'Error al tratar de cargos los pagos de la licencia.',
        showConfirmButton: false,
      })
    }).finally(() => commit('dashboard/load', false, { root: true }));

}

/**
 * Crear pagos.
 *
 * @param commit
 * @param dispatch
 * @param object payload: datos para el pago
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function storeMonthlyPayment({ commit, dispatch }, payload) {
  commit('dashboard/load', true, { root: true });

  await $http.post('licenses/monthly-payments', payload)
    .then(({ data: response }) => {
      if (response.statusCode == 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Pagos de la licencia',
          text: response.message,
          showConfirmButton: true,
        })

        commit('setDefaultMonthlyPayment');
        commit('setIsShowFormMonthlyPayment');
        dispatch('getAllByCompany', {
          idLicense: payload.slq_license_id,
          idCompany: payload.slq_company_id,
          page: 1,
          sortBy: payload.sortBy,
          sort: payload.sort,
          per_page: payload.per_page,
        });

        return false;
      }
        
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Pagos de la licencia',
        text: response.message,
        showConfirmButton: false,
      })

    })
    .catch(() => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Pagos de la licencia',
        text: 'Error al tratar de realizar la acción con el pago.',
        showConfirmButton: false,
      })
    })
    .finally(() => commit('dashboard/load', false, { root: true }));
  
}

/**
 * Actualizar pagos.
 *
 * @param commit
 * @param dispatch
 * @param object payload: datos para el pago
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function updateMonthlyPayment({ commit, dispatch }, payload) {
  commit('dashboard/load', true, { root: true });

  await $http.put(`licenses/monthly-payments/${payload.id}`, payload)
    .then(({ data: response }) => {
      if (response.statusCode == 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Pagos de la licencia',
          text: response.message,
          showConfirmButton: true,
        })

        commit('setDefaultMonthlyPayment');
        commit('setIsShowFormMonthlyPayment');
        dispatch('getAllByCompany', {
          idLicense: payload.slq_license_id,
          idCompany: payload.slq_company_id,
          page: 1,
          sortBy: payload.sortBy,
          sort: payload.sort,
          per_page: payload.per_page,
        });

        return false;
      }
        
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Pagos de la licencia',
        text: response.message,
        showConfirmButton: false,
      })

    })
    .catch(() => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Pagos de la licencia',
        text: 'Error al tratar de realizar la acción con el pago.',
        showConfirmButton: false,
      })
    })
    .finally(() => commit('dashboard/load', false, { root: true }));
  
}

/**
 * Cambiar el estado del pagos.
 *
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function chageStatusMonthlyPayment({ commit, dispatch }, { id, idCompany }) {
  commit('dashboard/load', true, { root: true });

  await $http.post(`licenses/monthly-payments/change-status/${id}/company/${idCompany}`)
    .then(({ data: response }) => {

      if (response.statusCode == 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Pagos de la licencia',
          text: response.message,
          showConfirmButton: true,
        })
        return false;
      }
        
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Pagos de la licencia',
        text: response.message,
        showConfirmButton: false,
      })

      dispatch('getAllByCompany', {
        idLicense: id,
        idCompany: idCompany,
        page: 1,
        sortBy: 'date_start',
        sort: 'asc',
        per_page: 10
      });
    })
    .catch(() => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Pagos de la licencia',
        text: 'Error al tratar de actualizar el estado del pago.',
        showConfirmButton: false,
      })
    }).finally(() => commit('dashboard/load', false, { root: true }));

}

